<div class="css-Selector_empresas selector_empresas" id="selector_empresas">
    <div class="css-Feldset_selector_empresas feldset_selector_empresas">
        <div class="css-Titulo_Feldset_selector_empresas titulo_feldset_selector_empresas">
            <p class="css-Titulo_selector_empresas titulo_selector_empresas">
                Seleccione una empresa</p>
        </div>
        <div class="css-contenido_Selector_empresas contenido_selector_empresas">
            <div class="buscador_empresa" *ngIf="buscador">
                <div class="formulario_buscador_empresa">
                    <app-alerta-error id="existe-error-permiso" tipo="warning"
                        mensaje_unico="El usuario tiene demasiadas empresas vinculadas. Ingrese los datos de la empresa con la que desea trabajar."></app-alerta-error>

                    <!-- Instance of sub-component comp-combo -->
                    <app-combo-default descripcion_etiqueta="" [(ngModel)]="tipoFiltro"
                        [opciones]="opcionesEmpresa"></app-combo-default>

                    <!-- Instance of sub-component comp-campo-default -->
                    <app-campo-default id="filtro_buscador_empresa" [placeholder_input]="obtenerPlaceHolderFiltro()"
                        [(ngModel)]="parametroFiltro" descripcion_etiqueta=""></app-campo-default>
                </div>
                <!-- Instance of sub-component comp-boton-terciario -->
                <app-boton-terciario-consulta boton_texto="Buscar" (boton_funcion)="realizarBusqueda()"
                    [disabled]="parametroFiltro.length == 0"></app-boton-terciario-consulta>

                <ng-container *ngIf="errorValidacion">
                    <app-alerta-error id="existe-error-permiso" mensaje_unico="{{mensajeError}}"></app-alerta-error>
                </ng-container>
            </div>
            <div class="css-listado_empresas listado_empresas" *ngIf="!buscador || busquedaRealizada">
                <!-- Instance of sub-component comp-snippet-empresa -->
                <app-snippet-empresa *ngFor="let empresa of empresas; let i = index" [empresaItem]="empresa"
                    [idEmpresa]="i" (empresaSeleccionada)="setEmpresa($event)"></app-snippet-empresa>
            </div>
            <div class="css-accion_corfirmar_empresa accion_corfirmar_empresa" *ngIf="!buscador || busquedaRealizada">
                <!-- Instance of sub-component comp-boton-secundario -->
                <app-boton-secundario-consulta boton_texto="Elegir empresa" (boton_funcion)="selecionarEmpresa()"
                    [disabled]="empresaSeleccionada == null"></app-boton-secundario-consulta>
            </div>

        </div>
    </div>
</div>